import { useMutation } from '@tanstack/react-query';

import { PackPopupType } from '@nf/types/promotion';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '@/hooks/query';

export const useUpdatePackPopupStates = () => {
	const apiBackendInfo = useApiBackendInfo();

	return useMutation({
		mutationFn: (popupTypes: Array<PackPopupType>) => {
			return fetchComposer.postWithBearer(`${apiBackendInfo.url}/Promotion/SetIsShowStatus`, {
				body: JSON.stringify({ popupTypes })
			})(apiBackendInfo.token);
		},
	});
};